import { Header } from 'src/components/Header';
import React from 'react';
import { TTemplateDefaultProps } from './TemplateDefault.types';
import classnames from 'classnames';
import s from './TemplateDefault.module.scss';

export const TemplateDefault: React.FC<TTemplateDefaultProps> = ({ className, children }) => {
  return (
    <div className={classnames(s.container, className)}>
      <Header />
      {children}
    </div>
  );
};
